import React from 'react';
import moment from 'moment';
import routes from 'src/constants/routes';
import Link from 'src/components/Link';
import Text from 'src/components/Text';
import styles from './styles.module.scss';

const Footer: React.FC = () => (
  <footer className={styles['footer']}>
    <div className={styles['container']}>
      <Text type="span" muted small className={styles['copyright']}>©ИнфорАС. {moment().year()}. Все права защищены</Text>
      <Link to={routes.privacyPolicy} target="_blank" className={styles['link']}>Политика конфиденциальности</Link>
    </div>
  </footer>
);

export default Footer;
